import { GridColumnConfig } from '../../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'ProjectID',
    field: 'projectID',
    filter: 'text',
    hide: true,
  },
  {
    title: 'Project',
    field: 'projectName',
    filter: 'text',
    searchable: true,
    navigate: true,
    width: '200',
  },
  {
    title: 'Project Code',
    field: 'projectCode',
    filter: 'text',
    width: '130',
    searchable: true,
  },
  {
    title: 'Builder Code',
    field: 'builderCode',
    filter: 'text',
    width: '130',
    searchable: true,
  },
  {
    title: 'Customer',
    field: 'customerName',
    filter: 'text',
    searchable: true,
    width: '200',
  },
  {
    title: 'Office',
    field: 'officeName',
    filter: 'text',
    searchable: true,
    width: '200',
  },
  {
    title: 'City',
    field: 'city',
    filter: 'text',
    searchable: true,
    width: '200',
  },
  {
    title: 'State',
    field: 'stateName',
    filter: 'text',
    width: '200',
  },
  {
    title: 'Zip',
    field: 'zipcode',
    filter: 'text',
    width: '100',
  },
  {
    title: 'Municipalities',
    field: 'municipalities',
    filter: 'text',
    searchable: true,
    width: '200',
  },
  {
    title: 'Lots/Units',
    field: 'unitsCount',
    filter: 'text',
    width: '120',
  },
  {
    title: 'Work Orders',
    field: 'workOrderCount',
    filter: 'numeric',
    searchable: true,
    width: '100',
  },
  // {
  //   title: 'Plans',
  //   field: 'plansCount',
  //   filter: 'numeric',
  //   searchable: true,
  //   width: '130',
  // },
  {
    title: 'Contacts',
    field: 'projectContactsCount',
    filter: 'text',
    searchable: true,
    width: '100',
  },
  {
    title: 'Status',
    field: 'projectStatus',
    filter: 'text',
    searchable: true,
    width: '100',
  },
];
